import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface BrowseByContainerEntityParams {
  header_text: string;
  layout_position: string;
}
export class BrowseByContainerEntity extends BaseEntityClass {
  header_text: string;
  layout_position: string;
  constructor(params: BrowseByContainerEntityParams) {
    super();
    this.type = "popular_categories_container"; // this is the legacy entity type, kept for reporting ease
    this.entity_version = 2;
    this.header_text = params.header_text;
    this.layout_position = params.layout_position;
  }
}
